import styled from '@emotion/styled';
import colors from '$variables/colors';
import { spacing, typography } from '$variables/theme';

export const Wrapper = styled.div`
  padding: ${spacing.xSmall} ${spacing.small};
  border-radius: 4px;
  background-color: ${colors.grey2};
  display: inline-block;
  white-space: nowrap;
`;

export const Grade = styled.div`
  font-size: 14px;
  font-weight: ${typography.fontWeightBold};
`;
